'use strict';

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var BinaryPropagator =
/*#__PURE__*/
function () {
  function BinaryPropagator() {
    _classCallCheck(this, BinaryPropagator);
  }

  _createClass(BinaryPropagator, [{
    key: "inject",
    value: function inject(spanContext, carrier) {}
  }, {
    key: "extract",
    value: function extract(carrier) {
      return null;
    }
  }]);

  return BinaryPropagator;
}();

module.exports = BinaryPropagator;